import VueRouter, { Route } from "vue-router";

// Bubblegum wrapper for vue-router throwing an error when trying to push the same path as the current one.
export function routerPush(instance: { $route: Route; $router: VueRouter }, path: string): void {
  if (instance.$route.fullPath !== path) {
    instance.$router.push({ path }).catch((error: any) => {
      if (error.name !== "NavigationDuplicated") {
        throw error;
      }
    });
  }
}
